import _ from "lodash";
import ApiClient from "../ApiClient";

export async function call<T = any>(
  method: string,
  iri: string,
  data: Record<string, any>,
  options: Record<string, any> = {}
): Promise<T> {
  options.body = JSON.stringify(data);
  return ApiClient.call(method, iri, options);
}

export async function apiGet<T = any>(
  iri: string,
  id: number | null = null,
  data: Record<string, any> = {},
  options: Record<string, any> = {}
): Promise<T> {
  let fullIri = id ? iri + "/" + id : iri;
  if (!_.isEmpty(data)) {
    const urlParams = new URLSearchParams(data);
    fullIri = fullIri + "?" + urlParams.toString();
  }
  return ApiClient.call("get", fullIri, options);
}

export async function apiGetText(iri: string, options: Record<string, any> = {}): Promise<string> {
  return ApiClient.getText(iri, options);
}

export async function apiPost<T = any>(
  iri: string,
  data: Record<string, any> | FormData = {},
  options: Record<string, any> = {},
): Promise<T> {
  options.body = data instanceof FormData ? data : JSON.stringify(data);
  return ApiClient.call("post", iri, options);
}

export async function apiPut<T = any>(
  iri: string,
  id: number | null,
  data: Record<string, any>,
  options: Record<string, any> = {}
): Promise<T> {
  const fullIri = id ? iri + "/" + id : iri;
  options.body = JSON.stringify(data);
  return ApiClient.call("put", fullIri, options);
}

export async function apiPatch<T = any>(
  iri: string,
  id: number | null,
  data: Record<string, any>,
  options: Record<string, any> = {}
): Promise<T> {
  const fullIri = id ? iri + "/" + id : iri;
  options.body = JSON.stringify(data);
  return ApiClient.call("patch", fullIri, options);
}

export async function apiDelete<T>(iri: string, id: number, options: Record<string, any> = {}): Promise<T> {
  const fullIri = iri + "/" + id;
  return ApiClient.call("delete", fullIri, options);
}

export async function apiToken(credentials: { email: string; password: string }): Promise<string> {
  return ApiClient.getToken(credentials);
}
